import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { JwtPayload } from 'jwt-decode';
import { KeycloakService } from 'keycloak-angular';
import { LayoutService } from './layout.service';
import { SuscripcionService } from './shared/services/suscripcion.service';

export interface JWTContent extends JwtPayload {
  memberId?: string;
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'fibras';

  constructor(
    private layoutService: LayoutService,
    private router: Router,
  ) {}

  ngOnInit() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        const currentRoute = event.urlAfterRedirects;

        const isButtonActive = ['/', '/unite'].includes(currentRoute);
        this.layoutService.setDonateButtonActive(isButtonActive);
      }
    });
  }
}
